module.exports = __webpack_public_path__ + "img/kw.3c06184f.svg";